import { gsap, lenis } from '../global/gsap';

const DISMISS_SCROLL_THRESHOLD = 25;

const initSkipNav = (element) => {
    const toggle = element.querySelector('.js-skip-toggle');
    let dismissed = false;
    let dismissedAt = 0;
    let expandedWidth = element.offsetWidth;
    let collapsedWidth = element.offsetHeight;
    let scrollThreshold = window.innerHeight / 2;

    const isCollapsed = () => element.classList.contains('scrolled');

    const remeasure = () => {
        const wasCollapsed = isCollapsed();
        element.style.width = '';
        expandedWidth = element.offsetWidth;
        collapsedWidth = element.offsetHeight;
        scrollThreshold = window.innerHeight / 2;
        gsap.set(element, { width: wasCollapsed ? collapsedWidth : expandedWidth });
    };

    const expand = () => {
        if (!isCollapsed()) return;
        element.classList.remove('scrolled');
        gsap.to(element, { width: expandedWidth, duration: 0.25, ease: 'power2' });
    };

    const collapse = () => {
        if (isCollapsed()) return;
        element.classList.add('scrolled');
        gsap.to(element, { width: collapsedWidth, duration: 0.25, ease: 'power2' });
    };

    window.addEventListener('resize', remeasure);

    lenis.on('scroll', ({ scroll }) => {
        if (dismissed) {
            if (Math.abs(scroll - dismissedAt) <= DISMISS_SCROLL_THRESHOLD) return;
            dismissed = false;
        }

        if (scroll > scrollThreshold) {
            collapse();
        } else {
            expand();
        }
    });

    toggle.addEventListener('click', () => {
        dismissed = true;
        dismissedAt = window.scrollY;
        expand();
    });
};

export { initSkipNav as default };
